module.exports = __webpack_public_path__ + "static/img/close.67ab2906.svg";